import { Reducer } from 'redux';
import { IImportDataState } from './types';
import { StudentActionTypes } from '../types';

const initialState: IImportDataState = {
  givenName: '',
  familyName: '',
  studentNo: '',
  email: '',
  offers: [],
};

const reducer: Reducer<IImportDataState> = (state = initialState, action) => {
  switch (action.type) {
    case StudentActionTypes.GET_STUDENT_RECORD_SUCCESS:
      return {
        ...initialState,
        ...action.payload.student.importData,
      };
    case StudentActionTypes.UPDATE_CONFLICT_SUCCESS:
    case StudentActionTypes.UPDATE_OFFER_EVIDENCE_SUCCESS:
      if (action.payload.importData) {
        return {
          ...initialState,
          ...action.payload.importData,
        };
      }
      return state;
    default:
      return state;
  }
};

export { reducer as importDataReducer };
